import { Skeleton, Stack, useTheme } from '@mui/material';

function ProspectHeaderSkeleton() {
    const tabWidths = [72, 136, 136, 96, 112];

    return (
        <Stack
            sx={{
                padding: '24px 24px 0px 24px',
                backgroundColor: 'neutral.white',
            }}
            spacing={1}
        >
            <Skeleton variant="text" width={220} height={24} />
            <Skeleton variant="text" width={280} height={40} />
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Skeleton variant="rounded" width={96} height={28} />
                    <Skeleton variant="text" width={220} height={24} />
                </Stack>
                <Stack direction="row" spacing={1.25} alignItems="center">
                    <Skeleton variant="rounded" width={160} height={28} />
                    <Skeleton variant="rounded" width={108} height={28} />
                </Stack>
            </Stack>
            <Stack direction="row" spacing={3} sx={{ pt: 2 }}>
                {tabWidths.map((width, index) => (
                    <Skeleton key={index} variant="text" width={width} height={36} />
                ))}
            </Stack>
        </Stack>
    );
}

function SummaryColumnSkeleton() {
    const theme = useTheme();

    return (
        <Stack
            sx={{
                borderRadius: '8px',
                border: `1px solid ${theme.palette.neutral.borderColor}`,
                backgroundColor: 'neutral.white',
                padding: '24px',
                gap: '18px',
                width: '100%',
            }}
        >
            <Skeleton variant="text" width={220} height={32} />
            <Skeleton variant="rounded" width="100%" height={42} />
            <Skeleton variant="rounded" width="100%" height={42} />
            <Skeleton variant="rounded" width="100%" height={42} />
            <Skeleton variant="text" width={180} height={32} />
            <Skeleton variant="rounded" width="100%" height={42} />
            <Skeleton variant="rounded" width="100%" height={42} />
            <Skeleton variant="text" width={160} height={32} />
            <Skeleton variant="rounded" width="70%" height={56} />
        </Stack>
    );
}

function SummaryContentSkeleton() {
    const theme = useTheme();

    return (
        <Stack sx={{ alignItems: 'center', gap: '24px' }}>
            <Stack
                sx={{
                    width: 'calc(100% - 48px)',
                    padding: '20px',
                    margin: '24px 24px 0px',
                    borderRadius: '8px',
                    border: `1px solid ${theme.palette.neutral.borderColor}`,
                    backgroundColor: 'neutral.white',
                }}
            >
                <Skeleton variant="rounded" width="100%" height={48} />
            </Stack>
            <Stack
                direction="row"
                sx={{
                    gap: '24px',
                    width: 'calc(100% - 48px)',
                    padding: '24px',
                }}
            >
                <SummaryColumnSkeleton />
                <SummaryColumnSkeleton />
            </Stack>
        </Stack>
    );
}

export default function ProspectDetailsSkeleton() {
    return (
        <Stack>
            <ProspectHeaderSkeleton />
            <SummaryContentSkeleton />
        </Stack>
    );
}
